import styled from 'styled-components'

import { getColor } from 'utils/rebrandingUtils'

export const LoaderFullScreenContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => getColor(theme, 'WHITE')};
  display: flex;
  height: 100vh;
  justify-content: center;
  position: absolute;
  width: 100%;
`
